import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { map } from 'lodash'
import { getSocialUrls, openPopup } from '../util/gif-social'

const onSocialClick = (e, type) => {
    e.preventDefault()
    openPopup(e.target.href, type)
}

const GifShare = ({ gif, css, onShare, isMobile }) => (
    <div className={css.social}>
        {map(getSocialUrls(gif, isMobile), (link, channel) => (
            <a
                href={link}
                key={channel}
                className={css[channel]}
                onClick={e => {
                    onSocialClick(e, channel)
                    onShare(channel)
                }}
            />
        ))}
    </div>
)

GifShare.propTypes = {
    css: PropTypes.object,
    gif: PropTypes.object,
    onShare: PropTypes.func,
    isMobile: PropTypes.bool,
}

export default GifShare
